/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_9_TitleInputs */

const en_terms_section_9_title = /** @type {(inputs: Terms_Section_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Limitation of Liability`)
};

const lv_terms_section_9_title = /** @type {(inputs: Terms_Section_9_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Atbildības ierobežojums`)
};

/**
* | output |
* | --- |
* | "9. Limitation of Liability" |
*
* @param {Terms_Section_9_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_9_title = /** @type {((inputs?: Terms_Section_9_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_9_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_9_title(inputs)
	return en_terms_section_9_title(inputs)
});